import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return <div className="min-h-screen flex items-center justify-center bg-ivory font-body text-ink/50">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
